import MichaelHaralson from 'assets/resources/MichaelHaralson.webp';
import TristanKlempka from 'assets/resources/TristanKlempka.webp';
import AILiveSimImage from 'assets/logo.webp';

interface IAuthor {
  author: string;
  authorImage: string;
  linkedInAuthorLink: string;
  isCompany?: boolean;
}

type TAuthorsNames = 'Michael Haralson' | 'AILiveSim' | 'Tristan Klempka';

export const AUTHORS: Record<TAuthorsNames, IAuthor> = {
  'Michael Haralson': {
    author: 'Michael Haralson',
    authorImage: MichaelHaralson,
    linkedInAuthorLink: 'https://www.linkedin.com/in/michael-haralson-3b57583',
  },
  AILiveSim: {
    author: 'AILiveSim',
    authorImage: AILiveSimImage,
    linkedInAuthorLink: 'https://www.linkedin.com/company/ailivesim',
    isCompany: true,
  },
  'Tristan Klempka': {
    author: 'Tristan Klempka',
    authorImage: TristanKlempka,
    linkedInAuthorLink: 'https://fr.linkedin.com/in/tristanklempka/fr',
  },
};
